import React from "react";
import Moment from "react-moment";
import pin from "../../../../Assets/Images/pin.svg";
import "./style.css";
import { ticketStateList } from "../../../../helper/general";
import moment from "moment";

const Table = ({ data, commentModal, ticketModal, type }) => {
  return (
    <div className="contact-accordion px-4 mb-5">
      <div className="contact-table-data-outer">
        <table class="table accodian-data-table">
          <thead>
            <tr>
              <th className="accordion-td">Ticket ID</th>
              <th className="accordion-td">Status</th>
              <th className="accordion-td">Date</th>
              <th className="accordion-td">{type === "OPEN" ? 'Expected response time' : 'Closing date'}</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => {
              return (
                <tr class="accordion-item" key={index}>
                  <td colspan="4">
                    <tr class={`accordion-button ${index === 0 ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#ticket-${item?.ticketDisplayId}`} aria-expanded={`${index === 0 ? 'true' : 'false'}`} aria-controls={`ticket-${item?.ticketDisplayId}`}>
                      <td className="accordion-td">{item?.ticketDisplayId}</td>
                      <td className="accordion-td">
                        <span className={`cstm-pill ${item?.ticketStatus?.toLowerCase()}`}>{ticketStateList[item?.ticketStatus]}</span>
                      </td>
                      <td className="accordion-td"><Moment format="DD MMM Y">{new Date(item?.ticketCreationTimestamp)}</Moment></td>
                      <td className="accordion-td">{item?.ticketStatus == "CLOSED" ? <Moment format="DD MMM Y">{new Date(item?.ticketClosingTimestamp)}</Moment> : '24 Hours'}</td>
                    </tr>
                    <tr colspan="4">
                      <td colspan="4 py-0">
                        <div id={`ticket-${item?.ticketDisplayId}`} class={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`} aria-labelledby={`ticket-${item?.ticketDisplayId}`}>
                          <div class="accordion-body px-2 py-3">
                            <div className="tab-text" onClick={() => commentModal(item)}>
                              <div className="d-flex justify-content-between">
                                <p className="fw-semibold"><b>Subject :</b> {item?.title}</p>
                                {item?.attachments?.length > 0 && <div className="upload-icon"><a href={item?.attachments?.[0]?.fileUrl} target="_blank"><img src={pin} alt="pin" style={{ width: "1.3rem", height: "1.3rem" }} className="pin" /></a></div>}
                              </div>
                              <p><b>Details</b></p>
                              <p className="fw-semibold">{item?.description}</p>
                            </div>
                            <div className={`comments ${item?.ticketStatus == "CLOSED" ? '' : 'float-end'} `}>
                              {item?.ticketStatus == "CLOSED" && <button onClick={() => commentModal(item)} className="btn old-comnt mb-0 fw-semibold p-0">View old conversation</button>}
                              {item?.ticketStatus != "CLOSED" && <div className="right-side-btns d-flex">
                                <button onClick={() => commentModal(item)} className="btn btn-left comment-btns me-3">Conversation</button>
                                <button onClick={() => ticketModal(item)} className="btn btn-right comment-btns border-0">Close ticket</button>
                              </div>
                              }
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </td>
                </tr>)
            })}
            {data?.length < 1 && <tr className="text-center"><td colSpan={4}>No data found!</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default Table;
